import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Modal, Button, Card, ProgressBar } from "react-bootstrap";
import { Link } from "react-router-dom";
import Admissionform from "../../Images/PDF/ISBMUniversity-Admission Form.pdf";
import bannerImage from "../../Images/student-services/complaints.webp";

const AdmissionProcedure = () => {
  const [uploadOpen, setUploadOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploadResponse, setUploadResponse] = useState(null);

  // Handle file selection
  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files);
    if (selected.length > 5) {
      alert("You can upload up to 5 files only.");
      return;
    }
    setFiles(selected);
  };

  // Upload files to PHP backend
  const handleUpload = async () => {
    if (files.length === 0) {
      alert("Please select at least one file.");
      return;
    }

    const formData = new FormData();
    files.forEach((file) => formData.append("files[]", file));

    setUploading(true);
    setProgress(0);

    try {
      const response = await fetch("https://isbmuniversity.edu.in/upload-documents.php", {
        method: "POST",
        body: formData,
      });

      const text = await response.text(); // 👈 Read raw text first
      console.log("Raw server response:", text);

      let result;
      try {
        result = JSON.parse(text); // 👈 Try to parse JSON
      } catch (err) {
        throw new Error("Invalid JSON response from server: " + text);
      }

      console.log("Parsed result:", result);
      setUploadResponse(result);
      setProgress(100);
      setUploading(false);

      if (result.status === "success") {
        alert("Files uploaded successfully!");
        setFiles([]);
      } else {
        alert(result.message || "uploaded successfully.");
      }
    } catch (error) {
      console.error("Error uploading:", error);
      alert("Upload failed. Please check console for details.");
      setUploading(false);
    }
  };

  return (
    <React.Fragment>
      <title>ISBM University Admissions | Step-by-Step Guide to Apply</title>
      <meta
        name="description"
        content="Explore ISBM University’s admission guidelines for a smooth application process. Follow step-by-step instructions to start your academic journey today."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Admission Procedure Guidelines</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Admission Procedure Guidelines
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="ptb-50">
        <div className="container-xxl">
          <div className="row justify-content-center">
            <div >
              <div>
                <div className="p-4 p-lg-5">
                  <h2 className="section-title modern-title text-center text-blue">Admission Procedure Guidlines</h2>
                  <p className="modern-subtitle text-center text-blue">ISBM University has multiple options available for efficient
                    and secure fee payment for students. Details regarding the
                    different modes of fee payment for students are given below.</p>
                  <div class="row g-4">
                    <div class="col-lg-6">
                      <div class="card p-2 border-0 shadow h-100">
                        <div class="card-header bg-white border-0 pb-0">
                          <h3 class="fw-semibold mb-3">Admission Requirements</h3>
                          {/* <p class="text-muted mb-0">Please prepare the following documents for your application:</p> */}
                        </div>
                        <div class="card-body pt-1">
                          <ul class="list-unstyled mb-0">
                            <li class="py-3 d-flex align-items-center border-bottom border-light-root">
                              <div class="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                                <i class="ti ti-check fs-5"></i>
                              </div>
                              <span>Photo Copies of Mark Sheets & Certificates</span>
                            </li>
                            <li class="py-3 d-flex align-items-center border-bottom border-light-root">
                              <div class="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                                <i class="ti ti-check fs-5"></i>
                              </div>
                              <span>Four Latest Photographs</span>
                            </li>
                            <li class="py-3 d-flex align-items-center border-bottom border-light-root">
                              <div class="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                                <i class="ti ti-check fs-5"></i>
                              </div>
                              <span>Identity Proof</span>
                            </li>
                            <li class="py-3 d-flex align-items-center border-bottom border-light-root">
                              <div class="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                                <i class="ti ti-check fs-5"></i>
                              </div>
                              <span>Address Proof</span>
                            </li>
                            <li class="py-3 d-flex align-items-center">
                              <div class="icon-sm bg-light-blue text-blue rounded-circle d-flex align-items-center justify-content-center me-3">
                                <i class="ti ti-check fs-5"></i>
                              </div>
                              <span>Work Experience Certificate if any</span>
                            </li>
                          </ul>
                        </div>
                        <div class="card-footer bg-white border-0 pt-0">
                          <div class="alert alert-light-blue border border-light-root mb-2">
                            <div class="d-flex">
                              <i class="ti ti-info-circle text-blue me-2 mt-1"></i>
                              <div>
                                <p class="mb-2"><strong>Note:</strong> All documents must be attested.</p>
                                <p class="mb-0"><strong>Eligibility:</strong> Please refer the list of Courses for details.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6">
                      <div class="card p-2 border-0 shadow h-100">
                        <div class="card-header bg-white border-0 pb-0">
                          <h3 class="fw-semibold mb-3">Application Procedure</h3>
                          {/* <p class="text-muted mb-0">Follow these steps to complete your application:</p> */}
                        </div>
                        <div class="card-body pt-1">
                          <div class="v-steps">
                            <div class="step-item guidelines py-3">
                              <div class="step-number bg-light-blue text-blue rounded-circle d-inline-flex align-items-center justify-content-center me-3">1</div>
                              <div class="step-content">
                                <p class="mb-1">Download the official application form from the university website in printable format.</p>
                                <a href="#" class="d-inline-flex align-items-center text-blue fw-semibold text-decoration-none">
                                  Download admission form
                                  <i class="ti ti-chevron-right ms-1 fs-xs"></i>
                                </a>
                              </div>
                            </div>
                            <div class="step-item guidelines py-3 border-bottom border-light-root">
                              <div class="step-number bg-light-blue text-blue rounded-circle d-inline-flex align-items-center justify-content-center me-3">2</div>
                              <div class="step-content">
                                <p class="mb-1">Fill out the form accurately and submit it either in person or post it to ISBM University’s admission office.</p>
                              </div>
                            </div>
                            <div class="step-item guidelines py-3 border-bottom border-light-root ">
                              <div class="step-number bg-light-blue text-blue rounded-circle d-inline-flex align-items-center justify-content-center me-3">3</div>
                              <div class="step-content">
                                <p class="mb-1">Make the fee payment using any of the available payment options listed on our website.</p>
                                <a href="/pay-fees-online" class="d-inline-flex align-items-center text-blue fw-semibold text-decoration-none">
                                  View payment options
                                  <i class="ti ti-chevron-right ms-1 fs-xs"></i>
                                </a>
                              </div>
                            </div>
                            <div class="step-item guidelines py-3">
                              <div class="step-number bg-light-blue text-blue rounded-circle d-inline-flex align-items-center justify-content-center me-3">3</div>
                              <div class="step-content">
                                <p class="mb-1">Ensure to carry all relevant academic and identity documents during verification or physical submission.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-light p-4 rounded-3 my-5 border-start border-4 border-purple">
                    <p className="mb-2">
                      <b>
                        Application Form is available at the Admission Cell,
                        ISBM University, Chhura, Gariyaband, Chattisgarh on cash
                        payment of 900 INR.
                      </b>
                    </p>
                    <div className="divider my-3">
                      <span className="px-2 bg-white text-dark fw-bold">
                        OR
                      </span>
                    </div>
                    <p className="mb-0">
                      <b>
                        Application form can be downloaded from website and sent
                        along with a DD of 900 INR in favor of 'ISBM
                        University', payable at Raipur and required to be sent
                        at the address given below:
                      </b>
                    </p>
                  </div>

                  <Card className="border-0 shadow-sm mb-5 bg-primary-soft">
                    <Card.Body className="p-4">
                      <h5 className="card-title fs-3 fw-bold section-title-start text-blue">
                        <i className="ti ti-info-alt me-2"></i> University Contact
                        Details
                      </h5>
                      <div className="contact-info">
                        <div className="d-flex align-items-center mb-3">
                          <div className="p-2 bg-blue text-white rounded-circle me-3">
                            <i className="fs-4 ti ti-location-pin"></i>
                          </div>
                          <div>
                            <h6 className="fw-bold mb-1 text-blue">Address</h6>
                            <p className="mb-0">
                              ISBM university: Village-Nawapara (Kosmi) Block,
                              Tehsil-Chhura, District: Gariyaband, Chhattisgarh
                              - 493996
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center mb-3">
                          <div className="p-2 bg-blue text-white rounded-circle me-3">
                            <i className="fs-4 ti ti-phone"></i>
                          </div>
                          <div>
                            <h6 className="fw-bold mb-1 text-blue">Contact</h6>
                            <p className="mb-0">+91 9373199999</p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="p-2 bg-blue text-white rounded-circle me-3">
                            <i className="fs-4 ti ti-mail"></i>
                          </div>
                          <div>
                            <h6 className="fw-bold mb-1 text-blue">Email</h6>
                            <p className="mb-0">info@isbmuniversity.edu.in</p>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>

                  <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                    <a
                      href={Admissionform}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-purple btn-lg px-4 py-3 d-flex align-items-center justify-content-center"
                    >
                      <i className="ti ti-download me-2 fs-5"></i> Download
                      Admission Form
                    </a>
                    <a
                      href="/apply-online"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-purple btn-lg px-4 py-3 d-flex align-items-center justify-content-center"
                    >
                      <i className="ti ti-external-link me-2 fs-5"></i>
                      Apply Online
                    </a>

                    <Button
                      variant="purple"
                      className="btn btn-outline-purple btn-lg px-4 py-3"
                      onClick={() => setUploadOpen(true)}
                    >
                      <i className="ti ti-upload me-2 fs-5"></i> Upload Documents
                    </Button>
                    {/* <a
                      href="https://isbmalumni.com/student/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-purple btn-lg px-4 py-3 d-flex align-items-center justify-content-center"
                    >
                      <i className="ti ti-search me-2 fs-5"></i> Track Application
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      {/* FILE UPLOAD MODAL */}
      <Modal show={uploadOpen} onHide={() => setUploadOpen(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Required Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="file"
            className="form-control"
            multiple
            accept="image/*,application/pdf"
            onChange={handleFileChange}
          />
          <small className="text-muted d-block mt-2">
            You can upload up to 5 files (PDF, JPG, PNG).
          </small>

          {files.length > 0 && (
            <ul className="mt-3 list-group small">
              {files.map((file, index) => (
                <li key={index} className="list-group-item">
                  {file.name}
                </li>
              ))}
            </ul>
          )}

          {uploading && (
            <div className="mt-3">
              <ProgressBar now={progress} label={`${progress}%`} animated />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setUploadOpen(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUpload} disabled={uploading}>
            {uploading ? "Uploading..." : "Upload"}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default AdmissionProcedure;
